export default __webpack_public_path__ + "static/media/fail_icon.3cc20f34.svg";